import { AppBar, Box, Button, Container, Toolbar, Typography } from '@mui/material'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Logo from '../../img/3knots-logo.png'

const pages = [
  { title: 'About Us', url: '/aboutus' },
  { title: 'Contact Us', url: '/contactus' },
]

const SiteHeader = () => {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <AppBar
      position='sticky'
      elevation={0}
      sx={{
        zIndex: 1100,
        background: 'rgba(10, 10, 15, 0.85)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      }}
    >
      <Container maxWidth='xl'>
        <Toolbar disableGutters sx={{ py: 0.5, minHeight: { xs: 64, md: 72 } }}>
          <Typography
            component={Link}
            to='/'
            sx={{
              display: 'flex',
              alignItems: 'center',
              mr: 2,
              textDecoration: 'none',
            }}
          >
            <Box
              component='img'
              src={Logo}
              alt='3Knots'
              sx={{
                width: { xs: 56, md: 64 },
                height: { xs: 56, md: 64 },
                objectFit: 'contain',
                transition: 'transform 0.25s ease',
                '&:hover': { transform: 'scale(1.04)' },
              }}
            />
          </Typography>

          <Box sx={{ flexGrow: 1 }} />

          <Box sx={{ display: 'flex', gap: { xs: 0.5, sm: 1 } }}>
            {pages.map((page) => {
              const isActive = location.pathname === page.url
              return (
                <Button
                  key={page.title}
                  onClick={() => navigate(page.url)}
                  sx={{
                    color: isActive ? '#fff' : 'rgba(255,255,255,0.75)',
                    fontWeight: isActive ? 700 : 500,
                    fontSize: { xs: '0.85rem', sm: '0.95rem' },
                    px: { xs: 1.5, sm: 2.5 },
                    background: isActive
                      ? 'rgba(237, 31, 36, 0.2)'
                      : 'transparent',
                    border: isActive
                      ? '1px solid rgba(237, 31, 36, 0.4)'
                      : '1px solid transparent',
                    '&:hover': {
                      background: 'rgba(237, 31, 36, 0.15)',
                      color: '#fff',
                    },
                  }}
                >
                  {page.title}
                </Button>
              )
            })}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default SiteHeader
